module.exports = __webpack_public_path__ + "static/media/testimoni1.09a0cb5f.png";